const MonetizationSlot = () => (
  <section className="mx-auto mt-8 max-w-4xl rounded-lg border border-dashed border-slate-300 bg-white px-4 py-5 text-center text-sm text-slate-500">
    广告或合作推荐位
  </section>
)

export default MonetizationSlot
